import logger from 'loglevel';
import { isBrowser } from './WebApi';
export function getDefaultNativeJwe(config) {
    if (config.nativeJwe) {
        logger.debug('Using nativeJwe from config');
        return config.nativeJwe;
    }
    if (!isBrowser) {
        return;
    }
    if (!window.__nativeJwe__ && !window.hermesJwe) {
        logger.debug('No __nativeJwe__ or hermesJwe found in window');
        return;
    }
    // Special support for Hybrid apps, using Pulse tracking and/or ad identifiers within a webview
    return window.__nativeJwe__ || window.hermesJwe;
}
export function getDefaultAltHandler(config) {
    if (config.altEventHandler) {
        logger.debug('Using altEventHandler from config');
        return config.altEventHandler;
    }
    if (!isBrowser) {
        return;
    }
    if (!window.pulseEventHandler) {
        logger.debug('No pulseEventHandler found in window');
        return;
    }
    // If the pulse event handler is set, e.g. by a native app in
    // a hybrid app setup, we pick that as the 'altEventHandler'
    return window.pulseEventHandler;
}
